// extracted by mini-css-extract-plugin
export default {"title":"Text_title__VZD0f","description":"Text_description__jf6vi","linking":"Text_linking__WriVt","styleSpanSmall":"Text_styleSpanSmall__sO-0D"};